/**
 * Description: to display the sidebar options to the user in profile page
 * Author: Trushita
 * From Scratch
 */

import React from "react";
import ProfileImage from "../../assets/images/profileImage.png";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import { Box, Divider, Paper, Typography } from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import { menu } from "../../data/sideMenuData";
import useStyles from "../../assets/css/sideMenu";
const SideMenu = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const navigateToPage = (link) => {
    history.push(link);
  };

  return (
    <Paper elevation={3}>
      <Box mt={1} display="flex" flexDirection="column" justifyContent="center">
        <Box
          pt={2}
          pb={4}
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <img
            className="sidebar-userphoto"
            alt="ProfileImage"
            src={ProfileImage}
            width={80}
            height={80}
          />
          <Typography variant="h5">John Brown</Typography>
        </Box>
        <Box ml={3} mr={3}>
          <Divider />
        </Box>
        <Box pl={4} mb={10} pr={4}>
          {menu.map((item) => (
            <List
              sx={{
                width: "100%",
                maxWidth: 360,
                bgcolor: "background.paper",
              }}
              className={classes.root}
            >
              <ListItem onClick={() => navigateToPage(item.link)}>
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: "#80d3f3" }}>{item.icon}</Avatar>
                </ListItemAvatar>
                <ListItemText primary={item.name} />
              </ListItem>
            </List>
          ))}
        </Box>
      </Box>
    </Paper>
  );
};

export default SideMenu;
